var _defs, _circle, _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDasmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2f2f2f;\n        stroke: #2f2f2f;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.5,
    cy: 26.5,
    r: 22.5
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    x: 14,
    y: 14,
    width: 25,
    height: 25,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAACNUlEQVRIibWWS0hVURSGv23vkq7Q26iEJhFINoiismlFIxsFEc2EmhYUNRESnBgWQbOIBhFERBE4cBDRqCCIGgQZVCAqKJmmSC/7Y12XtD3u21XvccF5/Xuv9e9/nbUfAUDSIqD4nrMphDARJN0CTgCDC0CyBug0kt/AXuADcBbYmEPwAeAmsA7orgIsVV+Ae64oD2sCnkxlZ3EU8DCwD/gE1CeIBLwCdgFLHev1Ue+O+r0Hqk0BsGLSc9Lq/NkgqV3SmKTPmeu7pEuS/jg+IKlb0mVJ444NS7ofxdtmt6rEiE3dgxBCXXwBL7ztm383u6IlQJdj1yKV0wLOxSaAgo3Yg/cAP4Fjji0HHlVK0g+cBFb6twUeA85EfZ5XSrIJaAVGSrSbksfAhUpIrNxHQgg1qUZJLUBDFk/9+EpsGfAj659SYnV+TlIjMBrh1VNqrNQTfpuB00DbbEhuA/uBh15BsfX4SJ8l/KzK7vpysmVaSzQZRyUdySNnkg5I+iVpvQWPlXRYZUjqz4HHFtnrrq6YLsv7UU/PG2BrwsmqaVUCHwe+JvBeX7uaikSSTkka1MLYkKTmsrolFTy/OzJ4rQ+rdg5pLElyRdK7Em0vJXWUizFjX5e0ATjvu9pOYI9vasMJ/wKwFngNvAWGgPYQQl85kk6feE+B7TNqPm19/qMP2lIfQjj0396SPloxzCJwyve4bWZZPDXjrwJ3JN2YB89q4GIWTJ61JBk+n3OYnbPsLPDPgL+Z8IM5zfgMsgAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDasmall);
export default __webpack_public_path__ + "static/media/dasmall.e5642de6.svg";
export { ForwardRef as ReactComponent };